export const BUDGET_HEADS_LIST = "budget_heads_list"; 
export const BUDGETHEADS_LIST = "budgetheads_list"; 
export const BUDGET_HEADS_LIST_SUCCESSFULL = "budget_heads_list_successfull";
export const BUDGETHEADS_LIST_SUCCESSFULL = "budgetheads_list_successfull";
export const CREATE_BUDGET_HEADS = "create_budget_heads";
export const CREATE_BUDGET_HEADS_SUCCESSFULL = "create_budget_heads_successfull";
export const UPDATE_BUDGET_HEADS = "update_budget_heads";
export const UPDATE_BUDGET_HEADS_SUCCESSFULL = "update_budget_heads_successfull";